import React, { ReactNode } from 'react';

interface SectionWrapperProps {
  children: ReactNode;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children }) => {
  return (
      <div className="mx-auto max-w-screen-2xl space-y-4">
        {children}
      </div>
  );
};

export default SectionWrapper;
